import { Stack, Button, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import StatusChip from "./StatusChip";

export const getColumns = (openDetail, handleSetujui, handleRevisi) => [

  { field: "no", headerName: "No", align: "center", headerAlign: "center", width: 60 },

  { field: "tanggal", headerName: "Tanggal", headerAlign: "center", width: 120 },

  { field: "nip", headerName: "NIP", headerAlign: "center", width: 150 },

  { field: "nama", headerName: "Nama Pegawai", headerAlign: "center", flex: 1, minWidth: 200},

  { field: "aktivitas", headerName: "Aktivitas", headerAlign: "center", flex: 2},

  { field: "durasi", headerName: "Durasi", align: "center", headerAlign: "center", width: 80 },

  {
    field: "status",
    headerName: "Status",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <StatusChip value={params.value} />
      </Box>
    ),
  },

  {
    field: "aksi",
    headerName: "Aksi",
    width: 300,
    sortable: false,
    filterable: false,
    headerAlign: "center", 
    align: "center",
    renderCell: (params) => {

      if (params.row.status !== "dikirim") return "-";

      return (
        <Stack 
          direction="row" 
          spacing={1}
          justifyContent="center"   
          alignItems="center"       
          sx={{ width: "100%", height: "100%" }} 
        >
          <Button
            size="small"
            variant="outlined"
            onClick={() => openDetail(params.row)}
          >
            Detail
          </Button>

          <Button
            size="small"
            color="success"
            variant="contained"
            startIcon={<CheckIcon />}
            onClick={() => handleSetujui(params.row.id)}
          >
            Setujui
          </Button>

          <Button
            size="small"
            color="error"
            variant="contained"
            startIcon={<CloseIcon />}
            onClick={() => handleRevisi(params.row.id)}
          >
            Revisi
          </Button>

        </Stack>
      );
    }
  }
];